export default __webpack_public_path__ + "static/media/indonesia_testing.2e296321.svg";